import { Chip, Stack } from '@mui/material'
import colors from '../../constants/colors'
import { IChips } from './types'

const chipStyle = {
  border: `1px solid ${colors.TAG_BORDER_BLUE}`,
  borderRadius: '.5rem',
  backgroundColor: colors.TAG_LIGHT_BLUE,
  color: colors.TAG_BLUE,
  typography: 'h5',
}

const Chips: React.FC<IChips> = ({
  values = [],
  handleRemove,
  disabled = false,
  customContainerStyle = {},
  customChipStyle = {},
}) => {
  const renderChips = () => {
    return values.map((chip, index) => (
      <Chip
        label={chip.label}
        onDelete={handleRemove ? () => handleRemove(chip.value as string) : undefined}
        sx={{ ...chipStyle, ...customChipStyle }}
        key={`${chip.label}+${index}`}
        disabled={disabled}
      />
    ))
  }
  return (
    <Stack className='t-chips-wrap' direction='row' sx={{ ...customContainerStyle }}>
      {renderChips()}
    </Stack>
  )
}

export default Chips
